









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModuleMain } from '@/views/ModuleMain.ts';
import LayoutBanner from '@/views/banner/LayoutBanner.vue';
import LayoutDemoView from '@/views/demoView/LayoutDemoView.vue';
import MapLayout from '@/views/emap/MapLayout.vue';
import SearchEnterprise from '@/views/searchEnterprise/SearchEnterprise.vue';
import Advertisement from '@/views/Advertisement/Advertisement.vue';
import EnterpriseTypeCount from '@/views/Advertisement/EnterpriseTypeCount.vue';
import CustomComponent from '@/views/Advertisement/CustomComponent.vue';
import NearbySearch from '@/views/NearbySearch/NearbySearch.vue';
// import Legend from '@/views/legend/Legend.vue';
@Component({
  name: 'App',
  components: {
    MapLayout,
    LayoutBanner,
    LayoutDemoView,
    SearchEnterprise,
    Advertisement,
    EnterpriseTypeCount,
    CustomComponent,
    NearbySearch,
    // Legend,
  },
})
export default class App extends Vue {
  private nearbyActive: any = false;
  private showCustomPanel: any = false;
  constructor() {
    super();
    ModuleMain.init();
  }
  private closeCustomComponent() {
    this.showCustomPanel = false;
  }
  private nearbyBtn() {
    this.nearbyActive = !this.nearbyActive;
  }
}
